module.exports = __webpack_public_path__ + "img/ff8dd71.png";